import { Component, Input } from '@angular/core';
import { Color } from '../../../../constants/color.constants';
import { Icons } from '../../../../constants/icons.constants';

@Component({
    selector: 'lsq-mobile-navigation-item',
    template: `
        <div class="mobile-navigation-item">
            <a
                *ngIf="!!routerLink"
                class="nav-link text-truncate"
                [ngClass]="{ 'is-child': isChild }"
                [routerLink]="routerLink"
            >
                {{ label }}
                <lsq-icon
                    *ngIf="showCaret"
                    class="mobile-navigation-item-caret"
                    [type]="icons.ChevronRight"
                    [color]="color.Gray"
                >
                </lsq-icon>
            </a>

            <a
                *ngIf="!routerLink && externalLink"
                class="nav-link text-truncate"
                [ngClass]="{ 'is-child': isChild }"
                [href]="externalLink"
                target="_blank"
            >
                {{ label }}
                <lsq-icon
                    *ngIf="showCaret"
                    class="mobile-navigation-item-caret"
                    [type]="icons.ChevronRight"
                    [color]="color.Gray"
                >
                </lsq-icon>
            </a>
        </div>
    `,
    styleUrls: ['./lsq-mobile-navigation-item.component.scss']
})
export class LsqMobileNavigationItemComponent {
    @Input() public label: string;
    @Input() public routerLink?: string;
    @Input() public externalLink?: string;
    @Input() public showCaret = false;
    @Input() public isChild = false;

    public icons = Icons;
    public color = Color;
}
